import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-alert-info-status-block-edit-bank-data',
	templateUrl: './alert-info-status-block-edit-bank-data.component.html',
	styleUrls: ['./alert-info-status-block-edit-bank-data.component.scss'],
})
export class AlertInfoBlockEditBankDataComponent implements OnInit {
	@Input() text: string;

	constructor() {}

	ngOnInit(): void {}
}
